var _defs, _polygon, _path, _path2, _rect, _path3, _polygon2, _path4, _rect2, _polygon3, _polygon4, _path5, _rect3, _rect4, _path6, _path7, _rect5, _rect6, _path8, _path9, _path10, _rect7, _rect8, _rect9, _path11, _path12, _path13, _rect10, _rect11, _rect12, _polygon5, _path14, _path15, _polygon6, _rect13, _path16, _rect14, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIbm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 235.9 94.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #1f70c1;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "235.5 6.8 196.3 6.8 198.7 .1 235.5 .1 235.5 6.8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131,.1h36.4l2.4,6.7h-38.8V.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.1,0c6,.6,11.2,2.7,15.6,6.7H51.7V0h50.4Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 45.8,
    height: 6.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.5,19.4h-43.7l2.4-6.7h41.3v6.7Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "174.3 19.4 131 19.4 131 12.7 171.9 12.7 174.3 19.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.9,12.7c.9,2.2,1.9,4.1,1.9,6.7H51.8v-6.7h71.1Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    y: 12.7,
    width: 45.8,
    height: 6.7
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "187.3 32 189.7 25.3 222.5 25.3 222.5 32 187.3 32"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "176.4 25.3 178.8 32 143.9 32 143.9 25.3 176.4 25.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.4,25.3c0,2.3-.3,4.7-1,6.7h-20v-6.7h21Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 12.8,
    y: 25.3,
    width: 19.7,
    height: 6.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 65,
    y: 25.3,
    width: 19.7,
    height: 6.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.3,39.2v5.1h-19.4v-6.7h36.9l2.3,6.2,2.2-6.2h37.2v6.7h-19.3v-5.1l-1.8,5.1h-36.4l-1.7-5.1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,37.6h56.4c-1.2,2.2-3.5,5-5.6,6.7h-50.8v-6.7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 12.8,
    y: 37.6,
    width: 19.7,
    height: 6.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 203.2,
    y: 50.2,
    width: 19.3,
    height: 6.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.3,50.2h-19.4v6.7h19.4v-6.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199.3,50.2c-.1,0-2.3,6.7-2.4,6.7h-27.4l-2.4-6.7h32.2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,50.2h50.7c2.3,1.9,4.4,4.3,6.1,6.7h-56.8v-6.7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 12.8,
    y: 50.2,
    width: 19.7,
    height: 6.7
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 203.2,
    y: 62.8,
    width: 19.3,
    height: 6.7
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 143.9,
    y: 62.8,
    width: 19.4,
    height: 6.7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.5,69.5l2.4-6.7h-23.3l2.4,6.7h18.5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,69.5v-6.7h20v6.7h-20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.6,62.8c1,2,1.1,4.4,1.3,6.7h-21.1v-6.7h19.8Z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 12.8,
    y: 62.8,
    width: 19.7,
    height: 6.7
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 203.2,
    y: 75.1,
    width: 32.3,
    height: 6.7
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 131,
    y: 75.1,
    width: 32.3,
    height: 6.7
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "188.1 81.8 178.3 81.8 175.9 75.1 190.4 75.1 188.1 81.8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,75.1v6.7h45.8v-6.7H0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.1,75.1c-.5,2.2-.9,4.9-2.5,6.7H51.8v-6.7h73.3Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "183.7 94.4 182.8 94.4 180.5 87.7 186 87.7 183.7 94.4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 203.2,
    y: 87.7,
    width: 32.3,
    height: 6.7
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.8,94.4v-6.7h66.4c-4.5,4.2-10.5,6.6-17.1,6.7h-49.3"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 131,
    y: 87.7,
    width: 32.3,
    height: 6.7
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.8,87.8v6.6H0v-6.7c0,.1,45.8.1,45.8.1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbm);
export default __webpack_public_path__ + "static/media/ibm.46059e03d72c98e0129534af3f493130.svg";
export { ForwardRef as ReactComponent };